import * as configUtils from "util/config";
import * as i18n from "util/i18n";

export const lotPaymentTypes = configUtils.getArray("lotPayments.types", ["PP", "PH"]);
export const thirdPaymentOptions = ["thirdPayment.providers", "thirdPayment.assets"];

export const statusTagColor = (state) => {
    switch (state) {
        case "PENDING":
            return "warning";
        // FIRMA COMPLETA
        case "PROCESSING":
            return "warning";
        case "PROCESSED":
            return "success";
        case "FINISHED":
            return "success";
        case "PROCESADO CONFORME":
            return "error";
        // GRIS
        case "PROCESADO CON RECHAZOS":
            return "error";
        case "FIRMA PENDIENTE VENCIDA":
            return "error";
        case "CANCELLED":
            return "error";
        case "FIRMA RECHAZADA CLIENTE":
            return "success";

        default:
            return "error";
    }
};
export const statusTag = (state) => i18n.get(`transaction.line.status.${state}`);

export const states = configUtils.getArray("payThirdParties.states", [
    "TODOS",
    "PENDIENTE DE FIRMA",
    "FIRMA COMPLETA",
    "FIRMA RECHAZADA",
    "FIRMA PENDIENTE VENCIDA",
    "ANULADO",
    "FALLO",
    "ENVIADO AL BANCO",
    "PROCESADO CONFORME",
    "PROCESADO CON RECHAZOS",
]);

export const getTransactionNumber = (extendedData, status) => {
    if (extendedData !== null && status === "PROCESSED") {
        try {
            const parsedObj = JSON.parse(extendedData);
            return parsedObj?.transactionNumber || null;
        } catch (error) {
            return null;
        }
    }
    return null;
};

export default lotPaymentTypes;
